import { toastr } from "react-redux-toastr";
import { client_v2, getApiErrorMessage } from "utils/api";

export const createSpeditor = async ({ name }) => {
  try {
    await client_v2.post("/speditors", {
      name,
    });

    toastr.success("Sukces", "Spedytor został dodany");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd podczas aktualizowania");
    throw error;
  }
};

export const updateSpeditor = async (id, { name }) => {
  try {
    await client_v2.put(`/speditors/${id}`, {
      name,
    });

    toastr.success("Sukces", "Spedytor został zaktualizowany");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd podczas aktualizowania");
    throw error;
  }
};

export const deleteSpeditor = async (id) => {
  try {
    await client_v2.delete(`/speditors/${id}`);

    toastr.success("Sukces", "Spedytor został usunięty");
  } catch (error) {
    toastr.error(
      "Błąd",
      getApiErrorMessage(error, "Wystąpił błąd podczas usuwania")
    );
    throw error;
  }
};
